<template>
  <div class="coming-soon">

    <div class="coming-soon-container" ref="comingSoonContainer">
      <div class="logo-container" ref="logoContainer">
        <img class="img-3" src="../assets/coming-soon/layer3_00001.png"/>
        <img class="img-2" src="../assets/coming-soon/layer2_00001.png"/>
        <img class="img-1" src="../assets/coming-soon/layer1_00001.png"/>
      </div>
    </div>

    <div class="title">
      coming soon
    </div>
  </div>
</template>

<script>
  export default {
    name: "ComingSoon",

    methods: {
      cssParallax() {
        document.documentElement.addEventListener('mousemove', event => {

          let cx = Math.ceil(document.documentElement.clientWidth / 2.0);
          let cy = Math.ceil(document.documentElement.clientHeight / 2.0);
          let dx = event.clientX - cx;
          let dy = event.clientY - cy;

          let tiltx = (dy / cy);
          let tilty = -(dx / cx);
          let radius = Math.sqrt(Math.pow(tiltx, 2) + Math.pow(tilty, 2));
          let degree = (radius * 5);

          this.$refs.comingSoonContainer.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
          this.$refs.logoContainer.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
        });
      },
    },

    mounted() {
      this.cssParallax();
    }
  }
</script>

<style lang="scss">
  @import "src/pages/ComingSoon";
</style>
